export enum Vertical {
  Gambling,
  Dating,
  Crypto,
  Betting,
}
